var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { bind } from "decko";
import { GenericInputElement } from "./genericinputfield";
import { FlexContainer } from "../grid/flexcontainer";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const maxWitdhInfoClass = css({
    background: getThemeColorVar("background", "lighter"),
    padding: "2.5px 5px",
    textAlign: "end",
});
const exceedMaxLengthClass = css({
    color: getThemeColorVar("negative", "default"),
    fontWeight: "bold",
});
export class TextArea extends GenericInputElement {
    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.defaultState);
    }
    handleChange(event) {
        this.setState({ isPristine: false });
        this.props.onValueChange &&
            this.props.onValueChange(event.target.value, this.validate(event.target.value).length === 0);
    }
    handleKeyDown(event) {
        if (event.key === "Enter") {
            const value = this.inputElRef ? this.inputElRef.value : "";
            this.props.onValueCommit &&
                this.props.onValueCommit(value, this.validate(value).length === 0);
        }
        this.props.onKeyDown && this.props.onKeyDown(event);
    }
    handleBlur(event) {
        const value = this.inputElRef ? this.inputElRef.value : "";
        this.props.onValueCommit &&
            this.props.onValueCommit(value, this.validate(value).length === 0);
        this.props.onBlur && this.props.onBlur(event);
    }
    renderInner() {
        const { maxLength } = this.props;
        return (React.createElement(FlexContainer, { direction: "col" },
            React.createElement("textarea", { ref: (el) => (this.inputElRef = el), rows: this.props.rows, value: this.props.value, placeholder: this.props.hint, disabled: this.props.disabled, autoFocus: this.props.autoFocus, onBlur: this.handleBlur, onChange: this.handleChange, onKeyDown: this.handleKeyDown, id: this.props.id, maxLength: maxLength, tabIndex: this.props.tabIndex, onFocus: this.defaultHandleFocus }),
            maxLength && (React.createElement("div", { className: cx(maxWitdhInfoClass) },
                React.createElement("span", { className: maxLength < this.props.value.length
                        ? cx(exceedMaxLengthClass)
                        : undefined }, this.props.value.length),
                " ",
                "/ ",
                this.props.maxLength))));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TextArea.prototype, "handleChange", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TextArea.prototype, "handleKeyDown", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TextArea.prototype, "handleBlur", null);
export default TextArea;
//# sourceMappingURL=textarea.js.map